import { ComplianceCaseStatus } from "~/graphql/supergraphEnums";
import {
  ONBOARDING_CLOSED,
  ONBOARDING_IN_PROGRESS,
  ONBOARDING_PENDING_REVIEW,
} from "./resolveOnboardingState";

const CASE_STATUS_BY_BUCKET: Record<string, ComplianceCaseStatus> = {
  [ONBOARDING_IN_PROGRESS]: ComplianceCaseStatus.InProgress,
  [ONBOARDING_PENDING_REVIEW]: ComplianceCaseStatus.PendingReview,
  [ONBOARDING_CLOSED]: ComplianceCaseStatus.Closed,
};

export const bucketToCaseStatus = (label: string): ComplianceCaseStatus =>
  CASE_STATUS_BY_BUCKET[label] ?? ComplianceCaseStatus.InProgress;
